import * as PubSub from 'pubsub-js'
import { Moment } from 'moment';
import { FocusedInputShape } from 'react-dates';

export type EventPayload = {
  start_date: Moment
  end_date: Moment
  source: string
  focusedInput: FocusedInputShape
}

const message = 'period_change'

export const publish = (payload: EventPayload) : void => {
  PubSub.publish(message, payload)
}

export const subscribe = (callback: (payload: EventPayload) => void) : string => {
  return PubSub.subscribe(message, (msg, data) => {
    callback(data)
  })
}

export const unsubscribe = (token : string) : void => {
  PubSub.unsubscribe(token)
}
